import React from "react";
import { IMaskInput } from "react-imask";
import PropTypes from "prop-types";
import { UswfInput } from "./UswfInput";
import { InputAdornment } from "@mui/material";

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
  props,
  ref
) {
  const { onChange, value, ...other } = props;

  return (
    <IMaskInput
      mask={Number}
      radix="."
      thousandsSeparator=","
      scale={2}
      unmask
      inputRef={ref}
      value={value.toString()}
      // DO NOT USE onChange TO HANDLE CHANGES!
      // USE onAccept INSTEAD
      onAccept={
        // depending on prop above first argument is
        // `value` if `unmask=false`,
        // `unmaskedValue` if `unmask=true`,
        // `typedValue` if `unmask='typed'`
        (value) => onChange({ target: { name: props.name, value } })
      }
      {...other}
    />
  );
});

NumericFormatCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export const MoneyInput = ({ max, min, ...props }) => {
  return (
    <UswfInput
      {...props}
      className="money-input"
      InputProps={{
        inputComponent: NumericFormatCustom,
        startAdornment: (
          <InputAdornment
            className="date-picker-icon-mobile-wrapper"
            position="start"
          >
            $
          </InputAdornment>
        ),
      }}
      onFocus={(e) => {
        e.target.select();
      }}
      inputMode="numeric"
    />
  );
};
